export function isStringEqualTo (string1, string2) {
  if (string1?.toLowerCase() === string2?.toLowerCase()) {
    return true
  }
  return false
}

export const alphanumericOnly = string => {
  let filteredString = string.replace(/[^a-z0-9]/gi, '')
  return filteredString
}

export const alphanumericWithSpaceOnly = string => {
  let filteredString = string.replace(/[^a-z0-9, ]/gi, '')
  return filteredString
}

export const alphabetsOnly = string => {
  let filteredString = string.replace(/[^a-z, ]/gi, '')
  return filteredString
}

export function isEmail (email) {
      let result = email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/)
    if (result?.[0]) {
        return true
    }
    return false
}

export function textWithFirstCharUpper (string) {
  if (string === undefined || string === null || string === '') {
    return string
  }








let tempText= string
.split(' ')
.map(s => s.charAt(0).toUpperCase() + s.slice(1))
.join(" ")
  return tempText;
}

export function textWithOnlyUpper (string) {
  if (string === undefined || string === null || string === '') {
    return string
  }
  return string.toUpperCase()
}

export function formatSentence(sentence) {
  if (!sentence || typeof sentence !== 'string') {
    return '';
  }

  // Trim any extra whitespace
  sentence = sentence.trim();

  // Capitalize the first letter and make the rest lowercase
  sentence = sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();

  // Ensure the sentence ends with a period, unless it already ends with a punctuation mark
  if (!/[.!?]$/.test(sentence)) {
    sentence += '.';
  }

  return sentence;
}


